function waitForEngraver(callback) {
  if (typeof window.engraver !== 'undefined' && typeof window.engraver.setText === 'function') {
    callback();
  } else {
    console.log('[Roman Date] Aguardando o carregamento do Customily...');
    setTimeout(() => waitForEngraver(callback), 200);
  }
}

function toRoman(num) {
  if (isNaN(num) || num <= 0 || num > 3999) return "";

  const romanMap = [
    { value: 1000, numeral: "M" },
    { value: 900, numeral: "CM" },
    { value: 500, numeral: "D" },
    { value: 400, numeral: "CD" },
    { value: 100, numeral: "C" },
    { value: 90, numeral: "XC" },
    { value: 50, numeral: "L" },
    { value: 40, numeral: "XL" },
    { value: 10, numeral: "X" },
    { value: 9, numeral: "IX" },
    { value: 5, numeral: "V" },
    { value: 4, numeral: "IV" },
    { value: 1, numeral: "I" }
  ];

  let result = "";
  for (let i = 0; i < romanMap.length; i++) {
    while (num >= romanMap[i].value) {
      result += romanMap[i].numeral;
      num -= romanMap[i].value;
    }
  }
  return result;
}

function initRomanFields() {

  /* =========================
     ANO
  ========================== */
  const yearField = document.querySelector('[class*="roman-year-source"]');
  if (yearField && !yearField.classList.contains('roman-year-initialized')) {

    yearField.classList.add('roman-year-initialized');
    const input = yearField.querySelector('input, textarea');

    if (input) {
      input.addEventListener('input', () => {

        let numericValue = input.value.replace(/\D/g, '');
        if (!numericValue) return;

        let year = parseInt(numericValue, 10);
        if (year < 1 || year > 3999) return;

        const roman = toRoman(year);

        waitForEngraver(() => {
          window.engraver.setText(1, roman); // 🔥 ID DO TEXTO DO ANO
        });

      });
    }
  }

  /* =========================
     MÊS
  ========================== */
  const monthField = document.querySelector('[class*="roman-month-source"]');
  if (monthField && !monthField.classList.contains('roman-month-initialized')) {

    monthField.classList.add('roman-month-initialized');
    const input = monthField.querySelector('input, textarea');

    if (input) {
      input.addEventListener('input', () => {

        let numericValue = input.value.replace(/\D/g, '');
        if (!numericValue) return;

        let month = parseInt(numericValue, 10);
        if (month < 1 || month > 12) return;

        const roman = toRoman(month);

        waitForEngraver(() => {
          window.engraver.setText(8, roman); // 🔥 ID DO TEXTO DO MÊS
        });

      });
    }
  }

  /* =========================
     DIA
  ========================== */
  const dayField = document.querySelector('[class*="roman-day-source"]');
  if (dayField && !dayField.classList.contains('roman-day-initialized')) {

    dayField.classList.add('roman-day-initialized');
    const input = dayField.querySelector('input, textarea');

    if (input) {
      input.addEventListener('input', () => {

        let numericValue = input.value.replace(/\D/g, '');
        if (!numericValue) return;

        let day = parseInt(numericValue, 10);
        if (day < 1 || day > 31) return;

        const roman = toRoman(day);

        waitForEngraver(() => {
          window.engraver.setText(11, roman); // 🔥 ID DO TEXTO DO DIA
        });

      });
    }
  }

}

document.addEventListener('DOMContentLoaded', () => {
  const checkFields = setInterval(() => {
    const hasField =
      document.querySelector('[class*="roman-year-source"]') ||
      document.querySelector('[class*="roman-month-source"]') ||
      document.querySelector('[class*="roman-day-source"]');

    if (hasField) {
      clearInterval(checkFields);
      initRomanFields();
    }
  }, 300);
});